import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { get } from 'lodash';
import NumberField from '../../app-main/components/reduxForms/fields/NumberField/NumberField';
import Currency from '../../elements-prices/Currency';
import { BASE_RATE_FORM } from './constants';
import onSubmitPriceForm from './submit/onSubmitPriceForm';
import validateBaseRateForm from './validate/validateBaseRateForm';
import { injectIntl, intlShape } from 'react-intl';

const BaseRateForm = ({
  handleSubmit = () => {},
  intl,
  ...props
}) => {
  return (
    <div>
      <Field name="prices._id" component="input" type="hidden" />
      <Field
        className="BaseRateInput"
      preInputElements={
        <Currency
          className="input-group-addon"
          id="base-rate"
          currency={get(props, 'listing.prices.0.currency')}
        />
      }
      placeholder={intl.formatMessage({ id: 'hosting.base_rate_form.rate_placeholder', defaultMessage: 'Rate' })}
      onBlur={handleSubmit(onSubmitPriceForm)}
      component={NumberField}
      name="prices.value"
      errorMessage={intl.formatMessage({ id: 'hosting.base_rate_form.error_message', defaultMessage: 'Please enter a valid price' })}
      />
    </div>
  );
};

BaseRateForm.propTypes = {
  handleSubmit: PropTypes.func,
  intl: intlShape
};

const config = {
  form: BASE_RATE_FORM,
  validate: validateBaseRateForm,
  enableReinitialize: true
};

export default reduxForm(config)(injectIntl(BaseRateForm));
